module.exports = __webpack_public_path__ + "static/media/icon_edit.09f30ab8.svg";